"use strict";

exports.__esModule = true;
exports.NavigationBar = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Breakpoints = require("../Breakpoints");
var _DesktopNavigationBar = require("./components/DesktopNavigationBar");
var _MobileNavigationBar = require("./components/MobileNavigationBar");
var _TabletNavigationBar = require("./components/TabletNavigationBar");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var NavigationBar = function NavigationBar(_ref) {
  var avatar = _ref.avatar,
    balance = _ref.balance,
    bonusCard = _ref.bonusCard,
    bonusEarningRate = _ref.bonusEarningRate,
    isNative = _ref.isNative,
    onClickAvatar = _ref.onClickAvatar,
    onClickUsername = _ref.onClickUsername,
    onClickViewAllBonuses = _ref.onClickViewAllBonuses,
    onInternalRoute = _ref.onInternalRoute,
    onLogin = _ref.onLogin,
    onLogOut = _ref.onLogOut,
    rightSideButtonClick = _ref.rightSideButtonClick,
    rightSideButtonLabel = _ref.rightSideButtonLabel,
    startButtonClick = _ref.startButtonClick,
    startButtonErrorClick = _ref.startButtonErrorClick,
    startButtonLabel = _ref.startButtonLabel,
    startButtonHoverLabel = _ref.startButtonHoverLabel,
    startButtonProgress = _ref.startButtonProgress,
    startButtonRunningTime = _ref.startButtonRunningTime,
    startButtonToolTip = _ref.startButtonToolTip,
    startButtonToolTipError = _ref.startButtonToolTipError,
    username = _ref.username;
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_Breakpoints.Desktop, {
      children: (0, _jsxRuntime.jsx)(_DesktopNavigationBar.DesktopNavigationBar, {
        avatar: avatar,
        balance: balance,
        bonusCard: bonusCard,
        bonusEarningRate: bonusEarningRate,
        isNative: isNative,
        onClickAvatar: onClickAvatar,
        onClickUsername: onClickUsername,
        onClickViewAllBonuses: onClickViewAllBonuses,
        onLogOut: onLogOut,
        onInternalRoute: onInternalRoute,
        username: username,
        rightSideButtonClick: rightSideButtonClick,
        rightSideButtonLabel: rightSideButtonLabel,
        startButtonClick: startButtonClick,
        startButtonLabel: startButtonLabel,
        startButtonHoverLabel: startButtonHoverLabel,
        startButtonErrorClick: startButtonErrorClick,
        startButtonProgress: startButtonProgress,
        startButtonRunningTime: startButtonRunningTime,
        startButtonToolTip: startButtonToolTip,
        startButtonToolTipError: startButtonToolTipError
      })
    }), (0, _jsxRuntime.jsx)(_Breakpoints.Tablet, {
      children: (0, _jsxRuntime.jsx)(_TabletNavigationBar.TabletNavigationBar, {
        avatar: avatar,
        balance: balance,
        bonusEarningRate: bonusEarningRate,
        isNative: isNative,
        onLogOut: onLogOut,
        onInternalRoute: onInternalRoute,
        username: username,
        rightSideButtonClick: rightSideButtonClick,
        rightSideButtonLabel: rightSideButtonLabel,
        startButtonClick: startButtonClick,
        startButtonLabel: startButtonLabel,
        startButtonHoverLabel: startButtonHoverLabel,
        startButtonErrorClick: startButtonErrorClick,
        startButtonProgress: startButtonProgress,
        startButtonRunningTime: startButtonRunningTime
      })
    }), (0, _jsxRuntime.jsx)(_Breakpoints.Mobile, {
      children: (0, _jsxRuntime.jsx)(_MobileNavigationBar.MobileNavigationBar, {
        avatar: avatar,
        balance: balance,
        isNative: isNative,
        onLogin: onLogin,
        onLogOut: onLogOut,
        onInternalRoute: onInternalRoute,
        username: username
      })
    })]
  });
};
exports.NavigationBar = NavigationBar;
NavigationBar.propTypes = {
  avatar: _propTypes.default.element,
  balance: _propTypes.default.number,
  bonusCard: _propTypes.default.element,
  bonusEarningRate: _propTypes.default.number,
  isNative: _propTypes.default.bool.isRequired,
  onClickAvatar: _propTypes.default.func,
  onClickUsername: _propTypes.default.func,
  onClickViewAllBonuses: _propTypes.default.func,
  onLogin: _propTypes.default.func,
  onLogOut: _propTypes.default.func,
  onInternalRoute: _propTypes.default.func.isRequired,
  rightSideButtonClick: _propTypes.default.func,
  rightSideButtonLabel: _propTypes.default.string,
  startButtonClick: _propTypes.default.func,
  startButtonErrorClick: _propTypes.default.func,
  startButtonLabel: _propTypes.default.string,
  startButtonHoverLabel: _propTypes.default.string,
  startButtonProgress: _propTypes.default.number,
  startButtonRunningTime: _propTypes.default.shape({
    value: _propTypes.default.number.isRequired,
    unit: _propTypes.default.oneOf(['year', 'month', 'week', 'day', 'hour', 'minute', 'second']).isRequired
  }),
  startButtonToolTip: _propTypes.default.string,
  startButtonToolTipError: _propTypes.default.bool,
  username: _propTypes.default.string
};